const THREE = require('three');
const OBJLoader = require('three-obj-loader');
import {ResourcesStorage} from '../../load/ResourcesStorage';

// ADD OBJLoader to THREE
OBJLoader(THREE);

const LoadObject = (id, url, doThat, critical, store = true, storage = null) => {
    const _storage = storage || ResourcesStorage.instance();

    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const manager = new THREE.LoadingManager();
        const loader = new THREE.OBJLoader(manager);
        loader.load(url, object => {
            if (store) _storage.add(id || url, object);

            resolve(object);
        });
    });
};

const LoadObjectFunction = (id, url, critical, store, storage) => {
    return doThat => {
        return LoadObject(id, url, doThat, critical, store, storage);
    };
};

export {LoadObject, LoadObjectFunction};
export default LoadObject;
